import { render } from "./FullPage.vue?vue&type=template&id=4c50ce39"
import script from "./FullPage.vue?vue&type=script&lang=js"
export * from "./FullPage.vue?vue&type=script&lang=js"

import "./FullPage.vue?vue&type=style&index=0&id=4c50ce39&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__